import React from "react";
import { registerPassages } from "../../Utils";
import variables from "../variables";
import missions from "../missions";
import Passage from "../../features/Passage";
import Link from "../../features/Link";
import V from "../../features/V";
import Image from "../../features/Image";
import Say from "../../features/Say";
import images, {getRandomImage} from "../images";
import {addTimePart, changeTimeTo, setOccupation} from "../features/functions";
import Video from "../../features/Video";
import constants from "../constants";
import places from "../places/places";
import people, {currentPlayer} from "../people/people";
import Name from "../../features/Name";
import {Trans} from "react-i18next";

registerPassages({

    oldLifeEnd: <Passage>
        <Trans i18nKey="day02.oldLifeEnd">
            1 <div style={{fontSize: "60px", fontWeight: "bold"}}/><br/><Link to="day02.story"/>
        </Trans>
    </Passage>,

    story: <Passage>
        <Trans i18nKey="day02.story">
            1<h3/><h3/><Image src={images.people.fatherPrison}/><Image src={images.other.funeral}/>
            <Image src={images.people.sister_.prison}/><Name who={people.sister}/><Link to="day02.sister"/>
            <Image src={images.story.court}/><Image src={images.story.houseForSale}/><Name who={people.wife}/>
            <Image src={images.story.vanDriver}/><Image src={images.places.homes.apartments01.homeMain}/><Name who={people.wife} nickname/>
            <Link to="game.changeDay" callback={() => {
                changeTimeTo(0, 0, 364);
                variables.game.nextDayLink = "day02.newMorning";
                variables.game.day02.started = true;
                variables.game.wasStarted = true;
                variables.game.car = "van";
                variables.game.home = "apartments01";
                people.wife.occupations.set("cook");
                people.wife.set("relations", 10);
                people.player.set("money", 590);
            }}/><br/>{{player: people.player.name}}
        </Trans>
    </Passage>,

    sister: <Passage>
        <Trans i18nKey="day02.sister">
            1<h1/><Name who={people.sister}/><h3/><Video src={images.people.sister_.prison01}/>
            <Video src={images.people.sister_.prison02}/><Say who=""/><Say who={people.sister}/>
            <Video src={images.people.sister_.prison03}/><Video src={images.people.sister_.prison04}/><br/>
            <Link to="day02.story"/>
        </Trans>
    </Passage>,

    newMorning: <Passage>
        <Trans i18nKey="day02.newMorning">
            1<h1/><h3/><div style={{color: "blue"}}/><Image src={images.places.homes.apartments01.homeBedroom}/>
            <Name who={people.wife}/><Image src={getRandomImage(images.wife.occupations.cook)}/>
            <Say who={people.player}/><Say who={people.wife}/><Name who={people.apartments01Keeper}/>
            <Image src={images.day02.manInMirror}/>
            <Link to="game.place" callback={() => {
                variables.game.rentPayed = false;
                people.wife.occupations.set("cook");
                addTimePart();
                people.player.setLocation(places.homeMain.id);}}/><br/>
            {{rentDay: constants.player.rentDay, player: people.player.name, wife: people.wife.name}}
        </Trans>
    </Passage>,

    goToWork: <Passage>
        <V callback={()=>{variables.game.day02.droveToWork = true}}/>
        <Trans i18nKey="day02.goToWork">
            1<h1/><Image src={images.player.drive.van}/><Name who={people.wife}/><Image src={images.other.pillsPack}/>
            <Name who={people.pillsManufacturer}/>
            <Link to="game.place" callback={() => {
                people.wife.occupations.set("reading");
                addTimePart();
                people.player.setLocation(places.courier.id);}}/>
        </Trans>
    </Passage>,

    backHomeFromWork: <Passage>
        <Trans i18nKey="day02.backHomeFromWork">
            1<h1/><Image src={images.player.opensDoor}/><Name who={people.wife} nickname/><Name who={people.wife}/>
            <Link to="" callback={() => {
                variables.game.day02.wentBackAfterHome = true;
                missions.initCorruption_01.start();
                currentPlayer.goTo(places.homeBedroom.id);}}/>
        </Trans>
    </Passage>
}, "day02");